import { message } from "antd";
import { makeObservable, observable } from "mobx";
import { get, post } from "../../services/request";
import {
  GET_WHITE_LIST,
  OPEN_WHITE_LIST,
  CLOSE_WHITE_LIST,
  GET_WHITE_LIST_STATE,
  ADD_WHITE_LIST_PHONE,
  REMOVE_WHITE_LIST_PHONE,
} from "../../services/request/urls";

export interface WhiteInfo {
  id: number;
  phone: string;
  createdTime: string;
}
class WhiteListStore {
  whiteList: WhiteInfo[];
  listState: boolean = true;
  constructor() {
    makeObservable(this, {
      whiteList: observable,
      listState: observable,
    });
    this.whiteList = [];
  }

  async getWhitePageList(phone: string = "") {
    const res = await post(GET_WHITE_LIST, { phone }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取白名单列表失败");
      return;
    }

    this.whiteList = res.data;
  }
  async openList() {
    const res = await post(OPEN_WHITE_LIST, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "打开白名单列表失败");
      this.listState = false;
      return;
    }
    message.success("打开白名单列表成功");
    this.listState = true;
  }
  async closeList() {
    const res = await post(CLOSE_WHITE_LIST, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "关闭白名单列表失败");
      this.listState = true;
      return;
    }
    message.success("关闭白名单列表成功");
    this.listState = false;
  }
  async getstate() {
    const res = await get(GET_WHITE_LIST_STATE, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取白名单开关失败");
      return;
    }

    this.listState = res.data === "true";
  }
  async addWhitePhone(phone: string[], roleId: string) {
    const res = await post(ADD_WHITE_LIST_PHONE, { phone, roleId }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "添加失败");
      return;
    }
    message.success("添加成功");
    this.getWhitePageList();
  }
  async removeWhitePhone(id: number) {
    const res = await post(`${REMOVE_WHITE_LIST_PHONE}?id=${id}`, { id }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "删除失败");
      return;
    }
    message.success("删除成功");
    this.getWhitePageList();
  }
}

export default new WhiteListStore();
